
import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Upload, Sparkles, CloudUpload } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function FileUploadZone({ onFileSelect, dragActive, setDragActive }) {
  const fileInputRef = useRef(null);

  const handleFileClick = () => {
    fileInputRef.current?.click();
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    const files = Array.from(e.dataTransfer.files);
    const imageFiles = files.filter((file) => file.type.startsWith('image/'));

    if (imageFiles.length > 0) {
      onFileSelect(imageFiles[0]);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      onFileSelect(file);
    }
  };

  return (
    <motion.div
      className={`relative overflow-hidden rounded-3xl transition-all duration-300 ${
      dragActive ?
      'bg-white/10 backdrop-blur-sm border-2 border-white/30 scale-[1.02]' :
      'bg-white/5 backdrop-blur-sm border border-white/10'}`
      }
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      whileHover={{ y: -4 }}
      transition={{ duration: 0.3, ease: "easeOut" }}>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        className="hidden" />

      
      <div className="p-10 md:p-16 text-center relative">
        <div className="relative z-10">
          <motion.div
            className="w-16 h-16 mx-auto mb-6 bg-white/10 rounded-2xl flex items-center justify-center"
            animate={{
              rotateY: dragActive ? 180 : 0,
              scale: dragActive ? 1.1 : 1
            }}
            transition={{ duration: 0.5, ease: "easeOut" }}>

            {dragActive ?
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.2 }}>

                <Sparkles className="w-8 h-8 text-white/60" />
              </motion.div> :

            <CloudUpload className="w-8 h-8 text-white/60" />
            }
          </motion.div>
          
          <motion.h3
            className="text-2xl font-light text-white mb-3 tracking-tight"
            animate={{ scale: dragActive ? 1.03 : 1 }}
            transition={{ duration: 0.2 }}>

            {dragActive ? 'Drop your itinerary here' : 'Upload Flight Itinerary'}
          </motion.h3>
          
          <p className="text-white/60 mb-8 max-w-md mx-auto font-normal leading-relaxed">Upload an image of your desired itinerary and our AI will extract all details with precision.

          </p>
          
          <div className="mb-4">
            <Button
              onClick={handleFileClick}
              className="bg-[var(--accent-color)] hover:bg-[var(--accent-color)]/90 text-white px-6 py-2.5 font-normal transition-all duration-300">

              <Upload className="w-4 h-4 mr-2" />
              Choose File
            </Button>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
